import React from "react";

import './styles.css'

import CloseIcon from '@mui/icons-material/Close';
import {
    //ButtonBase,
    //Button,
    Box,
    IconButton,
    
} from '@mui/material';

function PopUp(props){
  //const [choose, setChoose] = useState('Disponível');

  //const handleChoose = () => {
  //  setChoose('Escolhido');
  //}

  return (props.trigger) ? (
    <Box className="popup">
        <Box className="popup-inner">
            {/*props.ex.membros*/}
            <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                <CloseIcon/>
            </IconButton>
            {props.children}
        </Box>
    </Box>
      /*
      <div className="popup">
        <div className="popup-inner">
            <button className="close-btn" onClick={() => props.setTrigger(false)}>
            Fechar
            </button>
            {props.children}
        </div>
    </div>
    */
  ) : "";
}
export default PopUp
